export class SonIslemTarihiAyariEntity {
    id?: number;
    adi?: string;
    islemsizlik_uyari_gun_sayisi?: Date;
    created_at?: Date;
    updated_at?: Date;
}
